var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 532.3 730.5",
    style: {
      enableBackground: "new 0 0 532.3 730.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M420.8,22.2C393.8,7.4,353.5,0,299.8,0H0v730.5h299.8c82.2,0,141.5-19.9,177.9-59.8 c36.4-39.6,54.6-86.8,54.6-141.5c0-39.9-11.2-76.8-33.5-110.7c-22.3-33.9-55.7-56.5-100.3-68c77.3-27.2,115.9-81.3,115.9-162.3 c0-39.9-8.8-73.8-26.3-101.8C470.5,58.8,448,37.4,420.8,22.2 M316.8,134.4c10.7,3.2,20.6,11.5,29.7,24.9c8.7,13.4,13,29.4,13,48 c0,17.1-5.3,35-16,53.8c-10.9,18.6-37.3,27.9-79.1,27.9h-114V128.8h103.2C285.1,128.8,306.2,130.7,316.8,134.4 M150.4,419h122.2 c36.4,0,62.4,8.5,78,25.6c15.9,17.3,23.8,37.8,23.8,61.3c0,28.2-8.2,50.2-24.5,65.8C333.5,587.2,305.6,595,266,595H150.4V419z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldIcon);
export default __webpack_public_path__ + "static/media/bold_icon.90402b58.svg";
export { ForwardRef as ReactComponent };